import { Routes, Route } from 'react-router-dom'
import ScratchCard from './scratch-card-redemption/Page'
import Header from '../../shared/Header'
import { endUserAppleLuckyDrawBanner, endUserScratchCardBanner } from '../../constant/image'
import AppleLuckyDraw from './apple-products-lucky-draw/Page'

const Page = () => {
  return (
    <Routes>
      <Route element={<Header banner={endUserScratchCardBanner} />}>
        <Route path='/scratch-card-redemption' element={<ScratchCard />} />
      </Route>
      <Route element={<Header banner={endUserAppleLuckyDrawBanner} />}>
        <Route path='/apple-products-lucky-draw' element={<AppleLuckyDraw />} />
      </Route>
    </Routes>
  )
}

export default Page
